import React from 'react';
import cn from 'classnames';

import './index.scss';

type Props = {
  className?: string;
};

export default function SearchSpinner({ className }: Props) {
  return (
    <div
      className={cn(
        'd-flex align-items-center position-absolute rounded-lg bg-white flex-column pt-4 mb-0 w-100 h-50 search-spinner',
        className
      )}
    >
      <div>
        <span className="font-weight-bold">Searching...</span>
      </div>
      <div />
    </div>
  );
}
